import { UseControllerProps } from 'react-hook-form';

import { InputSize } from '@xemplo/input-utils';
import { XemploInputProps } from '@xemplo/xemplo-input';

export const SearchFieldSize = {
  Default: InputSize.Default,
  Compact: InputSize.Compact,
} as const;
export type SearchFieldSize = (typeof SearchFieldSize)[keyof typeof SearchFieldSize];

export type SearchFieldProps = Omit<XemploInputProps, 'type' | 'inputSize'> & {
  /** Defines the search input size */
  inputSize?: SearchFieldSize;

  /** The SearchField's clear button click handler */
  onClear?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export type SearchFieldRhfProps = Omit<SearchFieldProps, 'value' | 'onClear'> & {
  rules?: UseControllerProps['rules'];
};
